import Vue from 'vue';
import XNavbar from '@/apps/shared/components/navBar.vue';
import XFooter from '@/apps/shared/components/footer.vue';

export default Vue.extend({
  name: 'LayoutRetiro',
  components: { XNavbar, XFooter }
});